<template>
  <div class="notification">
    <div class="block">
      <van-tabs
        v-model="active"
        border
        color="#31D5BF"
        title-active-color="#101010"
        line-width="131px"
        @click="gettab"
      >
        <van-tab title="未签字告知书"></van-tab>
        <van-tab title="已签字告知书"></van-tab>
      </van-tabs>

      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="onLoad"
      >
        <van-empty description="" v-if="list.length == 0" />
        <van-cell
          is-link
          v-for="(item, index) in list"
          :key="index"
          class="aic"
          @click="todetail(item)"
          v-else
        >
          <div class="list_item">
            <div class="flex aic">
              <div class="name">{{ item.customerName }}</div>
              <div class="btn" :class="{ bgh: active == 0 }">
                {{ active == 0 ? "未签字" : "已签字" }}
              </div>
            </div>
            <div class="desc">{{ item.company }} | {{ item.product }}</div>
            <div class="desc">{{ item.updateTime }}</div>
          </div>
        </van-cell>
      </van-list>
    </div>
    <!-- <div class="bottombar">
      <van-button type="primary" size="large" style="width:80%" round @click="() => this.$router.push({ path: '/createnotice',query:{userId:this.userId} })">创建告知书</van-button>
    </div> -->
    <img
      src="../../assets/img/client/add.png"
      class="add"
      @click="() => this.$router.push({ path: '/createnotice',query:{userId:this.userId} })"
    />
  </div>
</template>
<script>
import { getnotice } from "../../api/notice";
import {setyoumeng} from '../../utils/index'
export default {
  data() {
    return {
      finished: false,
      loading: false,
      list: [],
      active: 0,
      page: 0,
      isFinished: false,
      userId: "",
      iscan:true
    };
  },
  methods: {
    onLoad() {
      if(!this.iscan){
        return
      }
      let data = {
        page: this.page,
        size: 10,
        sort: "id,desc",
        isFinished: this.isFinished,
        userId: this.userId,
      };
      this.iscan=false
      getnotice(data).then((res) => {
        console.log(res);
        if (res.content.length > 0) {
          if(this.page==0)this.list=[]
          this.list = this.list.concat(res.content);
          this.page++;
          this.loading = false;
        } else {
          this.loading = false;
          this.finished = true;
        }
        this.iscan=true
      });
    },
    gettab(val) {
      this.active = val;
      this.isFinished = val === 0 ? false : true;
      this.finished = false;
      this.page = 0;
      this.list = [];
      this.onLoad()
    },
    todetail(item){
      let url='/unsign'
      sessionStorage.setItem("cansign",1)//关闭签字保存按钮
      this.$router.push({path:url,query:{id:item.id,userId:this.userId}})
    }
  },
  mounted() {
    setyoumeng("https://s9.cnzz.com/z_stat.php?id=1279766199&web_id=1279766199")
    this.userId = this.$route.query.userId;
    console.log(this.$route)
  },
  // beforeRouteLeave (to, from, next) {
  //   console.log(from)

  //      from.meta.keepAlive=true
    
   
  //   next()
  // },
  activated(){
    let update=sessionStorage.getItem('update')//初始化缓存
    console.log(update)
    if(update==1){
      this.finished=false,
      this.loading= false,
      this.list= [],
      this.active= 0,
      this.page= 0,
      this.isFinished=false,
      this.iscantrue
      this.onLoad()
      sessionStorage.removeItem("update")
    }
  }

};
</script>
<style lang="less" >
.notification {
  width: 100%;
  padding-bottom: 120px;
  .van-tab {
    font-size: 15px !important;
  }
  .van-tab--active {
    font-size: 18px !important;
  }
  .van-tabs__line {
    height: 1px;
  }
  .block {
    width: 358px;
    margin: 19px auto;
    // padding: 0 10px;
    background: #fff;
    box-sizing: border-box;
    .list_item {
      padding-top: 13px;
      .name {
        color: rgba(16, 16, 16, 100);
        font-size: 18px;
        text-align: left;
        font-family: SourceHanSansSC-bold;
      }
      .btn {
        width: 54px;
        height: 21px;
        line-height: 20px;
        border-radius: 100px;
        background-color: rgba(89, 186, 118, 100);
        color: rgba(255, 255, 255, 100);
        font-size: 11px;
        text-align: center;
        font-family: Roboto;
        border: 1px solid rgba(255, 255, 255, 100);
        margin-left: 16px;
      }
      .bgh {
        background: #c1cdd1;
      }
      .desc {
        width: 327px;
        color: rgba(80, 85, 89, 100);
        font-size: 12px;
        text-align: left;
        line-height: 36px;
        font-family: SourceHanSansSC-regular;
      }
    }
  }
  .add {
    width: 41px;
    height: 41px;
    position: fixed;
    right: 24px;
    bottom: 114px;
  }
  .bottombar{
    width: 100%;
    height: 80px;
    line-height: 80px;
    text-align: center;
    position: fixed;
    bottom: 0;
    background: #fff;
  }
}
</style>